import { TextFilterProps } from '@progress/kendo-react-data-tools'
import { useAppSelector } from 'store'

import { MultiSelectFilter } from '../MultiSelectFilter'

export const TradingAccountGroupFilter: React.FC<TextFilterProps> = (props) => {
  const { filter, onFilterChange } = props
  const tradingAccountGroups = useAppSelector((state) => state.tradingAccounts.tradingAccountGroup)
  const data = tradingAccountGroups.map((x) => ({ id: x.id, label: x.name, value: x.id }))

  return (
    <MultiSelectFilter
      placeholder='Account Group'
      filter={filter}
      onFilterChange={onFilterChange}
      data={data}
    />
  )
}

export const TradingLiveAccountGroupFilter: React.FC<TextFilterProps> = (props) => {
  const { filter, onFilterChange } = props
  const tradingAccountGroups = useAppSelector(
    (state) => state.tradingAccounts.tradingAccountLiveGroup
  )
  const data = tradingAccountGroups.map((x) => ({ id: x.id, label: x.name, value: x.id }))

  return (
    <MultiSelectFilter
      placeholder='Account Group'
      filter={filter}
      onFilterChange={onFilterChange}
      data={data}
    />
  )
}

export const TradingDemoAccountGroupFilter: React.FC<TextFilterProps> = (props) => {
  const { filter, onFilterChange } = props
  const tradingAccountGroups = useAppSelector(
    (state) => state.tradingAccounts.tradingAccountDemoGroup
  )
  const data = tradingAccountGroups.map((x) => ({ id: x.id, label: x.name, value: x.id }))

  return (
    <MultiSelectFilter
      placeholder='Account Group'
      filter={filter}
      onFilterChange={onFilterChange}
      data={data}
    />
  )
}

export const TradingWelcomeAccountGroupFilter: React.FC<TextFilterProps> = (props) => {
  const { filter, onFilterChange } = props
  const tradingAccountGroups = useAppSelector(
    (state) => state.tradingAccounts.tradingAccountWelcomeGroup
  )
  const data = tradingAccountGroups.map((x) => ({ id: x.id, label: x.name, value: x.id }))

  return (
    <MultiSelectFilter
      placeholder='Account Group'
      filter={filter}
      onFilterChange={onFilterChange}
      data={data}
    />
  )
}
